import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { useAuth } from "../helper/useAuth";

interface UpdateCampaignStatusParams {
  campaign_id: string | number;
  google_campaign_id: string;
  status: string;
}

export const useUpdateCampaignStatus = () => {
  const queryClient = useQueryClient();
  const { selectedIntegration } = useAuth();

  return useMutation<any, Error, UpdateCampaignStatusParams>({
    mutationFn: async (params: UpdateCampaignStatusParams) => {
      return httpService.post<any, UpdateCampaignStatusParams>(
        API_CONFIG.path.campaignsStatus,
        params,
        { tracking_id: selectedIntegration?.value as string },
      );
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["google-ads-campaign-detail", String(variables.campaign_id)],
      });
      queryClient.invalidateQueries({
        queryKey: ["campaigns"],
      });
    },
  });
};
